.annotationBtn {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 24px;
  padding: 0;
  background: transparent;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  transition:
    transform 0.15s ease,
    z-index 0s; /* instant z-index change */
  opacity: 1 !important; /* Ensure annotation buttons are always fully visible */
  z-index: 1; /* Base z-index for stacking context */
}

.annotationBtn:focus-visible {
  outline: 2px solid #0d6efd;
  outline-offset: 2px;
}

.glyph {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon {
  width: 20px;
  height: 20px;
  border-radius: 3px;
  background: #0d6efd;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.15s ease;
}

.icon.wide {
  width: 32px;
}

.badEmpty .icon {
  background: #dc3545;
}

.empty .icon {
  background: #6c757d;
}

.empty:hover .icon {
  background: #0d6efd;
}

.letter {
  font-family: Arial, sans-serif;
  font-size: 14px;
  font-weight: bold;
  color: white;
  line-height: 1;
  transition: opacity 0.15s ease;
}

.hoverIcon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  color: white;
  transition: opacity 0.15s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.annotationBtn:hover .letter {
  opacity: 0;
}

.annotationBtn:hover .hoverIcon {
  opacity: 1;
}
